import { render, staticRenderFns } from "./ElectronicConsent.vue?vue&type=template&id=165d8094"
import script from "./ElectronicConsent.vue?vue&type=script&lang=js"
export * from "./ElectronicConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports